// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"tableContainer-35UwP table-TeK-j tableStriped-2Hp_v","totalsRow":"totalsRow-ylEqR tableRowEmphasized-2sPoE"};